<template>
  <div class="loading-screen">
    <div class="spinner" />
  </div>
</template>

<style scoped>
.loading-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: white;
}
.spinner {
  width: 128px;
  height: 128px;
  border: 3px solid #e6e6e6;
  border-top-color: #207d57;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
